export enum GamePageState {
  INFO = "info",
  CONFIG = "config",
  PLAY = "play",
}

interface State {
  page: GamePageState;
}

export const PageReducer = (state: State, payload: GamePageState) =>  {
  return  { page: payload };
};
